function Blog() {
    return <h2>Blog Page</h2>;
}

export default Blog;
